
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/ConfigProvider/index.md?watch=parent';
    export const demoIndex = {
  ids: ["configprovider-demo-plot-theme","configprovider-demo-map-config","configprovider-demo-components-config","configprovider-demo-graph-components-config"],
  getter: () => import(/* webpackChunkName: "meta__ConfigProvider" */'/home/runner/work/GPT-Vis/GPT-Vis/src/ConfigProvider/index.md?type=demo')
};